import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Headers from "../components/Headers";

import Footer from "../components/Footer";
import { get_products } from "../store/reducers/homeReducer";
const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const { products, latest_product, topRated_product, discount_product } =
    useSelector((state) => state.home);
  useEffect(() => {
    dispatch(get_products());
  }, []);

  return (
    <div className="w-full">
      <section
        className="h-[280px] bg-cover bg-no-repeat relative bg-center"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/pripol.jpg)`,
        }}
      >
        <Headers />
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto mt-20 ">
            <div className="div-gradient-t1">
              <h1 className="sm:text-[25px] text-[45px] gradient-t0">
                Politique de Confidentialité - سياسة الخصوصية
              </h1>
              <div className="w-[200px] sm:w-[150px] h-[8px] bg-[#fefefe] rounded-full"></div>
            </div>
          </div>
        </div>
      </section>

      <div className=" px-[10%] pb-20 flex justify-center items-center flex-col">
        <div className="block mt-10">
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-center">
            سياسة الاستخدام منصة طبيبي للرعاية الصحية
          </h1>
          <p className="mt-6 text-md sm:text-sm text-slate-600 text-right">
            {" "}
            14/02/2025 أخر تحديث{" "}
          </p>
        </div>
        <div className="div-gradient-t1">
          <h1 className="sm:text-[16px] gradient-t1 text-center">
            مرحبا بكم في منصة طبيبي ،المنصة الرقمية المتخصصة في تسهيل الوصول الى
            الخدمات الطبية ،بما في ذالك حجز مواعيد ،ادارة السجلات الصحية
            ،التواصل مع الأطباء والمتجر الالكتروني للمنتجات الصحية. قبل استخدام
            المنصة يرجي قراءة سياسة الاستخدام بعناية ،حيث يشكل دخولك واستخدامك
            لها موافقة ضمنية على شروط والاحكام أدناه .
          </h1>
        </div>
        <div className="block my-5 text-right items-end w-full">
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right">
            {" "}
            - التعريفات: - 1 -{" "}
          </h1>
          <p className="mt-2 text-lg sm:text-md text-mainColor font-bold text-right">
            - المنصة -
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            تشير الى موقع وتطبيق طبيبي وجميع الخدمات المرتبطة به
          </p>
          <p className="mt-2 text-lg sm:text-md text-mainColor font-bold text-right">
            - المستخدم -
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            اي شخص يقوم باستخدام المنصة سواء كان مريضا أو طبيبا أو مزود خدمة
            صحية
          </p>
          <p className="mt-2 text-lg sm:text-md text-mainColor font-bold text-right">
            - الخدمات -
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            تشمل حجز المواعيد ،السجلات الطبية الرقمية ،استشارات ،متجر الالكتروني
            و أي ميزات أخري تقدمها المنصة
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - شروط الاستخدام: - 2 -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            . يجب أن يكون المستخدم قد بلغ السن القانوني لاستخدام الخدمات أو أن
            يكون تحت اشراف ولى أمره -
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            .يلتزم المستخدم يتقديم معلومات دقيقة عند التسجيل والاستخدام ،ويتحمل
            المسؤولية الكاملة عن أي بيانات غير صحيحة -
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            . يحظر استخدام المنصة لأي غرض غير قانوني ،احتيالي ،أو ينتهك حقوق أي
            طرف أخر -
          </p>

          <p className="sm:text-[18px] text-lg gradient-t1 text-center mt-8">
            تلتزم المنصة بتوفير بيئة أمنة وموثوقة
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - خدمات المنصة : - 3 -{" "}
          </h1>
          <p className="mt-2 text-lg sm:text-md text-mainColor font-bold text-right">
            3-1 - للمرضى -
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            يمكن للمريض البحث عن الأطباء المتاحين وحجز المواعيد بسهولة عبر
            المنصة . يتيح السجل الطبي الرقمي للمستخدمين تخزين ومتابعة معلوماتهم
            الصحية بأمان -توفر المنصة امكانية التواصل مع الأطباء من خلال نظام
            الدردشة وفق شروط الاشتراك -يخضع الاشتراك لرسوم سنوية قدرها 1000 دج
            مع فترة تجريبية مجانية لمدة شهر
          </p>
          <p className="mt-2 text-lg sm:text-md text-mainColor font-bold text-right">
            3-2 - الأطباء -
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            يتيح التسجيل المجاني للأطباء أدارة مواعيدهم والتواصل مع المرضى
            بكفاءة يشترط على الأطياء تقديم معلومات مهنية دقيقة والامتثال
            للمعايير الطبية والاخلاقية
          </p>
          <p className="mt-2 text-lg sm:text-md text-mainColor font-bold text-right">
            3-3 - المتجر الالكتروني -
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            يوفر طبيبي متجرا الكترونيا للمنتجات الصحية موثوقة ،مع امكانية الطلب
            والتوصيل . الاسعار والموصفات قد تتغير دون اشعار مسبق وفقا لسياسات
            الموردين{" "}
          </p>

          <p className="mt-2 text-lg sm:text-md text-mainColor font-bold text-right">
            3-4 - المقالات -
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            يمكن للمستخدمين الاطلاع على المقالات الطبية ومشاركتها لاغراض شخصية
            أو تعليمية لا يجب الاعتماد على المقالات الطبية كمرجع حصري لتحديد
            العلاج او اتخاذ قرارات طبية. جميع القرارات الطبية يجب ان تكون مبنية
            على استشارة مباشرة مع طبيب مختص{" "}
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 4 - : الخصوصية وحماية البيانات -{" "}
          </h1>

          <p className=" text-md sm:text:sm text-slate-600 text-right">
            تلتزم منصة طبيبي بحماية بيانات المستخدمين وفق معايير الأمان المتعددة
            لا تتم مشاركة البيانات الشخصية أو الطبية مع أي طرف ثالث دون موافقة
            المستخدم ،الا اذا كان ذالك مطلوبا قانونيا . يحق للمستخدم طلب حذف
            حسابه وبياناته في أي وقت وفق سياسة الخصوصية .
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 5 - : حدود المسؤولية -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            طبيبي لا تقدم استشارات طبية مباشرة ،بل تسهل الوصول الى مقدمي الرعاية
            الصحية . لا تتحمل المنصة أي مسؤولية عن القرارات الطبية المتخذة بناءا
            على معلومات المقدمة عبرها منصة طبيبي هي وسيط يربط بين المرضى
            والأطباء ،لكنها لا تقدم تشخيصا طبيا مباشرا ولا تتحمل نتائج قرارات
            الاطباء أو المرضى .
          </p>

          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 6 - : التعديلات على سياسة الاستخدام -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            يحق لمنصة طبيبي تعديل هذه السياسة في أي وقت،وسيتم اشعار المستخدمين
            بالتغيرات الجوهرية عبر البريد الالكتروني او داخل المنصة . استمرار
            استخدام المنصة بعد التعديلات يعني الموافقة الضمنية على شروط الجديدة
            .{" "}
          </p>

          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 7 - : التواصل والدعم -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            لأي استفسارات أو شكاوى ،يمكنكم التواصل معنا عبر{" "}
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            CONTACT@TABBIBI.COM: البريد الالتروني
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            الهاتف :0671754591{" "}
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            عن طريق الدردشة مباشرة
          </p>

          <p className="sm:text-[16px] text-lg gradient-t1 text-center mt-8">
            تلتزم المنصة بتوفير بيئة أمنة وموثوقة نحن ملتزمون بتقديم خدمات
            موثوقة وأمنة لضمان أفضل تجربة ممكنة لمستخديمينا
            <br /> شكرا لاختياركم منصة طبيبيّ
          </p>
        </div>
        <hr className=" bg-mainColor h-1 w-full my-5" />
        <div className="block mt-10">
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-center">
            سياسة حماية البيانات الشخصية منصة طبيبي
          </h1>
          <p className="mt-6 text-md sm:text-sm text-slate-600 text-right">
            {" "}
            14/02/2025 أخر تحديث{" "}
          </p>
        </div>
        <div className="block my-5 text-right items-end w-full">
          <p className="sm:text-[16px] text-lg gradient-t1 text-center mt-8">
            تحترم منصة طبيبي خصوصية المستخدمين وتلتزم بحماية بياناتهم الشخصية
            وفقا للقوانين الجزائرية المتعلق بحماية البيانات الشخصية . لا سيما
            القانون رقم 18-07
            <br /> توضح هذه السياسة كيفية جمع بياناتكم الشخصية واستخدامها
            وحمايتها عند استخدامكم لخدماتنا
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 1 - : البيانات التي نجمعها -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            : عند استخدامكم لمنصة طبيبي قد نقوم بجمع البيانات التالية
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            المعلومات الشخصية :الاسم،اللقب، البريد الالكتروني،رقم الهاتف
            ،العنوان
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            المعلومات الصحية :بيانات طبية ضرورية لحجز مواعيد ،تخزين السجلات
            الطبية (فى حالة تقديم الخدمة)
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            ،بيانات الاستخدام مثل عنوان الجهاز سجل التصفح داخل المنصة . IPنوع
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 2 - : كيفية استخدام البيانات -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            : نسخدم بياناتكم الشخصية للأغراض التالية
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            حجز مواعيد الطبية توفير استشارات طبية وادارة الحسابات
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            التواصل مع المستخدمين لارسال اشعارات أو تحديثات حول الخدمات
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 3 - : مشاركة البيانات مع أطراف ثالثة -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            لا نقوم ببيع أو تأجير بياناتكم الشخصية لأي طرف ثالث وقد تشارك مع
            الاطباء المسجلين في المنصة لغرض تقديم الخدمات الطبية
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 4 - : حماية البيانات -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            نتخذ اجراءات تقنية وادارية لحماية بياناتكم من الوصول غير المصرح به
            أو تعديل أو فقدان ،بما في ذالك تشفير البيانات الحساسة
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            أنظمة حماية متقدمة لمنع الاختراقات
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            تقييد الوصول الى البيانات بناءا على الحاجة
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 5 - : حقوق المستخدمين -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            وفقا للقوانين الجزائرية ،يحق للمستخدمين الوصول الى بياناتهم الشخصية
            وطلب تصحيحها أو تحديثها
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            طلب حذف بياناتهم عند عدم الحاجة اليها
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            الاعتراض على معالجة بيانتهم لأغراض تسويقيىة
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            تقديم شكاوى الى السلطات المختصة في حالة انتهاك الخصوصية .
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 6 - : التعديلات على سياسة -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            قد نقوم بتحديث هذه السياسة من وقت لأخر ،وسيتم اشعاركم بأي تغييرات
            حوهرية عبر البريد الالكتروني او داخل المنصة
          </p>
          <h1 className="sm:text-[22px] text-xl gradient-t1 text-right mt-8">
            {" "}
            - 7 - : الاتصال بنا -{" "}
          </h1>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            لأي استفسارات أو طلبات متعلقة بالخصوصية ،يمكنكم التواصل معنا
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            CONTACT@TABBIBI.COM: البريد الالتروني
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            {" "}
            الهاتف :0671754591{" "}
          </p>
          <p className=" text-md sm:text:sm text-slate-600 text-right">
            العنوان : جامعة باجي مختار - عنابة (القطب الجامعي سيدي عاشور)
          </p>
          <p className="sm:text-[16px] text-lg gradient-t1 text-center mt-8">
            باستخدامكم لمنصة طبيبي ،فانكم توافقون على سياسة حماية البيانات هذه
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
